<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
  #formRef="ngForm"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          type="button"
          aria-controls="filterNaming"
        >
          <span class="fs-3">{{ 'tagModule.filterNaming' | translate }}</span>
          <span>
            <i
              class="fa fa-fw"
              [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
              attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
              role="img"
            ></i>
          </span>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="filterNaming">
      <fieldset class="mb-4">
        <legend class="form-label" id="primaryFilterLabel"
          >{{ 'general.primaryFilter' | translate }}
        </legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-id0"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="primaryFilterLabel flag-nl-id0"
                formControlName="primaryfilterDisplayNameNl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-id0"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="primaryFilterLabel flag-en-id0"
                formControlName="primaryfilterDisplayNameEn"
              />
            </div>
          </div>

          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flat-fr-id0"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="primaryFilterLabel flag-fr-id0"
                formControlName="primaryfilterDisplayNameFr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flat-de-id0"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="primaryFilterLabel flag-de-id0"
                formControlName="primaryfilterDisplayNameDe"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="mb-4">
        <legend class="form-label" id="secondaryFilterLabel"
          >{{ 'general.secondaryFilter' | translate }}
        </legend>

        <div class="row g-2">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-id1"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="secondaryFilterLabel flag-nl-id1"
                formControlName="secondaryfilterDisplayNameNl"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flat-en-id1"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="secondaryFilterLabel flag-en-id1"
                formControlName="secondaryfilterDisplayNameEn"
              />
            </div>
          </div>

          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-id1"
                ></span
              ></span>

              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="secondaryFilterLabel flag-fr-id1"
                formControlName="secondaryfilterDisplayNameFr"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-id1"
                ></span
              ></span>
              <input
                type="text"
                class="form-control"
                rows="8"
                aria-labelledby="secondaryFilterLabel flag-de-id1"
                formControlName="secondaryfilterDisplayNameDe"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
</form>
